import { Pipe, PipeTransform } from "@angular/core";
import { WeightConversionPipe } from "./weight-conversion.pipe";

@Pipe({
  name: "weightDetails"
})
export class WeightDetailsPipe implements PipeTransform {
  weightConversionToPipe = new WeightConversionPipe();

  transform(price): string {
    return `Actual Weight: ${this.weightConversionToPipe.transform(
      price.deadWeight,
      "kg"
    )} Kg\nVolumetric Weight: ${this.weightConversionToPipe.transform(
      price.volWeight,
      "kg"
    )} Kg\n*Higher of the two will be charged.`;
  }
}
